import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Heading, Text } from "@chakra-ui/layout";
export function ErrorMessage(props) {
  return /*#__PURE__*/_jsxs(Box, {
    mt: "4",
    p: "2",
    border: "1px solid",
    borderColor: "red.300",
    borderRadius: "2",
    "data-testid": "error-message",
    children: [/*#__PURE__*/_jsx(Heading, {
      fontWeigth: "bold",
      pb: "1",
      color: "red.500",
      fontSize: "md",
      children: props.title
    }), /*#__PURE__*/_jsx(Text, {
      color: "red.500",
      fontSize: "md",
      children: props.message
    })]
  });
}